import { render, staticRenderFns } from "./printBillingLabel.vue?vue&type=template&id=b3f70f0c&"
import script from "./printBillingLabel.vue?vue&type=script&lang=js&"
export * from "./printBillingLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports